import styles from './styles.less';
import { observer } from 'mobx-react';


const NewsHeadlinePropType = React.PropTypes.shape({
    headline: React.PropTypes.string,
    posted: React.PropTypes.string,
    url: React.PropTypes.string,
    newTab: React.PropTypes.bool
});


function NewsHeadline(props) {
    return (
        <a className={ cx(styles.root, props.className) }
            href={ props.newsHeadline.url || null }
            target={ props.newsHeadline.newTab ? '_blank' : null }>
            <div className={ styles.content }>
                <div className={ styles.headline }>
                    { props.newsHeadline.headline }
                </div>
                { !!props.newsHeadline.posted &&
                <div className={ styles.posted }>
                    Posted { props.newsHeadline.posted }
                </div> }
            </div>
        </a>
    );
}

NewsHeadline.propTypes = {
    newsHeadline: NewsHeadlinePropType.isRequired
};


export { NewsHeadlinePropType };
export default observer(NewsHeadline);



// WEBPACK FOOTER //
// ./src/show-page/components/news-headline/index.js